// extracted by mini-css-extract-plugin
export default {"container":"style_container__jsAz6","page":"style_page__VlzmQ","error":"style_error__ORA5Y"};